module.exports = __webpack_public_path__ + "c9a69d745914214f7f9a2160d875dcbf.svg";